import { styled } from "@mui/material/styles";

// Global across every styledComponent() call — never add a name that's also
// a real MUI prop (size, checked, fontSize, ...), it'll get stripped app-wide.
// Prefix one-off styling props instead (e.g. `pillSize`).
const CUSTOM_PROPS = new Set([
  "isDark",
  "open",
  "active",
  "bold",
  "fullHeight",
  "truncate",
  "danger",
  "isLast",
  "isHovered",
  "isSelected",
  "isAlreadyAdded",
  "isSaving",
  "readOnly",
  "columns",
  "pressed",
  "expanded",
  "status",
  "visible",
  "columnWidth",
  "bg",
  "border",
  "isCurrentMonth",
  "isStart",
  "isEnd",
  "inRange",
  "isToday",
  "filled",
  "accent",
]);

export const styledComponent = component =>
  styled(component, {
    shouldForwardProp: prop => !CUSTOM_PROPS.has(prop),
  });
